import {List, Map} from 'immutable';
import defaultDialogReducer from '../../defaultDialogReducer';
import {dialogsNames} from '../../../enums/dialogsNames';
import { actionTypes as actionTypes }  from '../../../actions/Dialogs/CreateSpoolFromCassettesDialog/createSpoolFromCassettesDialogActions';

let defaultState = {
  loading: false,
  show: false,
  preselectedAssets: List(),
  items: null,
};

export default function(state = Map(defaultState), action) {
  switch (action.type) {
    case actionTypes.CREATE_SPOOL_FROM_CASSETTES_SHOW:
      return state.set('preselectedAssets', action.payload?.map((item) => _convertAssetDataToDialogItem(item)) ?? List())
        .set('show', true);

    default:
      return defaultDialogReducer(state, action, dialogsNames.CREATE_SPOOL_FROM_CASSETTES, defaultState);
  }

}

function _convertAssetDataToDialogItem(item = {}) {

  const {id, businessId, lengthLeft, widthInCentimeter: width, weight, material, alertStatus} = item;
  return {id, businessId, lengthLeft, width, weight, material, alertStatus};
}

